import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Edit from '@material-ui/icons/Edit';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { makeStyles } from '@material-ui/core/styles';

import { Pending, Paid } from 'variables/status';

const styles = {
  button: {
    height: "48px"
  },
  deleteIcon: {
    color: "#FF0000"
  },
  iconContainer: {
    marginRight: "24px",
    minHeight: "48px"
  }
};

const useStyles = makeStyles(styles);

const CustomToolbar = (props) => {

  const classes = useStyles();

  const handleEdit = () => {
    props.setUpdate();
  };

  const handleDelete = () => {
    props.setDelete();
  };

  const renderAll = () => {
    switch (props.switchy) {
      
      //for Sales Orders.
      //values: selectedRows.data.length
      //functions: handleRefundsModalOpen, handleModalOpen
      case 0:
        return (
          <React.Fragment>
            <Tooltip title={"Refund Product(s)"}>
              <Button className={classes.button} onClick={props.handleRefundsModalOpen.bind(this)}>
                Refund Products
              </Button>
            </Tooltip>
            <Tooltip title={"Cancel Sales Order"}>
              <IconButton className={classes.button} onClick={props.handleModalOpen.bind(this, true)}>
                <DeleteForever className={classes.deleteIcon} />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        )
      
      //for PurchaseOrders.
      //values: status, received
      //functions: approvePurchaseOrder, handleModalOpen, receiveProductsOrPayment
      case 1:
        return (
          <React.Fragment>
            { props.status === Pending ?
              <React.Fragment>
                <Tooltip title={"Approve P.O."}>
                  <Button className={classes.button} onClick={props.approvePurchaseOrder}>
                    Approve
                  </Button>
                </Tooltip>
                <Tooltip title={"Cancel Purchase Order"}>
                  <IconButton className={classes.button} onClick={props.handleModalOpen}>
                    <DeleteForever className={classes.deleteIcon} />
                  </IconButton>
                </Tooltip>
              </React.Fragment> :
              <React.Fragment>
                { !props.received ?
                <Tooltip title={"Receive Products(s)"}>
                  <Button className={classes.button} onClick={props.receiveProductsOrPayment.bind(this, true)}>
                    Receive Products
                  </Button>
                </Tooltip> : null }
                { props.status === Paid ? null :
                <Tooltip title={"Make Payment"}>
                  <Button className={classes.button} onClick={props.receiveProductsOrPayment.bind(this, false)}>
                    Make Payment
                  </Button>
                </Tooltip> }
              </React.Fragment>
            }
          </React.Fragment>
        )
      
      //for customers.
      //values: --
      //functions: handleCreditModalOpen, setUpdate
      case 2:
        return (
          <React.Fragment>
            <Tooltip title={"Settle Customer Credit"}>
              <Button className={classes.button} onClick={props.handleCreditModalOpen}>
                Settle Credit
              </Button>
            </Tooltip>
            <Tooltip title={"Edit Customer"}>
              <IconButton className={classes.button} onClick={handleEdit}>
                <Edit />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        )
      
      //for products and vendors.
      //values: element
      //functions: setUpdate
      case 3:
        return (
          <Tooltip title={`Edit ${props.element}`}>
            <IconButton className={classes.button} onClick={handleEdit}>
              <Edit />
            </IconButton>
          </Tooltip>
        )
      
      //for categories, companies, expenses and expense types.
      //values: element
      //functions: setDelete
      case 4:
        return (
          <Tooltip title={`Delete ${props.element}`}>
            <IconButton className={classes.button} onClick={handleDelete}>
              <DeleteForever className={classes.deleteIcon} />
            </IconButton>
          </Tooltip>
        )
      
      //for employees.
      //values: --
      //functions: updateExpectedSalary, setUpdate
      case 5:
        return (
          <React.Fragment>
            <Tooltip title={"Update Expected Salary"}>
              <Button className={classes.button} onClick={props.updateExpectedSalary}>
                Expected Salary
              </Button>
            </Tooltip>
            <Tooltip title={"Edit Employee"}>
              <IconButton className={classes.button} onClick={handleEdit}>
                <Edit />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        )
      
      default:
        return (<React.Fragment></React.Fragment>)
    }
  };

  return (
    <div className={classes.iconContainer}>
    {renderAll()}
    </div>
  )
};

export default CustomToolbar;